import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import toastr from 'toastr';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { ButtonGroup, NeutralButton, PrimaryButton } from 'widgets-v5/buttons';
import Card from 'widgets-v5/card';
import CenterLayout from 'widgets-v5/center-layout';
import FormField from 'widgets-v5/form-field';
/** import widgets in the section above, Sort Lines Ascending */

import { getApiErrorMessage } from 'utils/http/get-api-error-message';
import { redirectLoggedInUserFromTokenLink } from 'common/token-link-guard';
import PasswordActions from 'states/resources/password/actions';
import selector from './selector';
/** import single application imports in the section above, Sort Lines Ascending */

class ForgotPassword extends React.Component {
    state = { emailError: null };

    /**
     * Redirects authenticated users away from forgot-password with the shared warning toast.
     */
    componentDidMount() {
        redirectLoggedInUserFromTokenLink(this.props.profile, '', { requireToken: false });
    }

    handleSubmit = e => {
        e.preventDefault();
        this.setState({ emailError: null });
        const email = this.refs.email.value && this.refs.email.value.trim();

        if (!email) {
            this.setState({ emailError: 'A valid e-mail address is required.' });
            return;
        }
        this.props.dispatch(PasswordActions.forgot(email)).then(
            () => {
                browserHistory.push(`/`);
                toastr.success(`An email containing the reset link has been sent to ${email}.`);
            },
            response => {
                if (response.code === 404) {
                    this.setState({
                        emailError:
                            'E-mail address not found. If you already have an account, please contact us at help@engagefront.com',
                    });
                    return;
                } else if (response.code === 405) {
                    this.setState({
                        emailError:
                            'Email link login is enabled for this account. Cannot reset password.',
                    });
                    return;
                } else {
                    // Non-404 errors: show API message inline (Urban validates email in middleware).
                    this.setState({
                        emailError: getApiErrorMessage(
                            response,
                            'An error has occurred, please try again.'
                        ),
                    });
                }
            }
        );
    };

    render() {
        const emailError = this.state.emailError;
        // Prefill from password-login route state when available.
        const prefilledEmail = this.props.location.state?.email || '';
        return (
            <CenterLayout className="ef5-forgot-password">
                <div>
                    <img className="ef5-forgot-password__logo" src="/images/EngageFront-logo.png" />
                    <Card
                        className="ef5-forgot-password__card"
                        title="Reset Password"
                        footer={
                            <ButtonGroup>
                                <NeutralButton text="Cancel" link="/" />
                                <PrimaryButton text="Send E-mail" onClick={this.handleSubmit} />
                            </ButtonGroup>
                        }
                    >
                        <form ref="login-form" method="POST" onSubmit={this.handleSubmit}>
                            <p className="ef5-forgot-password__instructions">
                                Enter the e-mail address you use to sign in and we'll send you a
                                link containing instructions to reset your password.
                            </p>
                            <FormField
                                label="E-mail"
                                isRequired={true}
                                showErrors={!!emailError}
                                errors={[emailError]}
                            >
                                <input
                                    className="ef3-stdInput"
                                    defaultValue={prefilledEmail}
                                    ref="email"
                                    type="text"
                                />
                            </FormField>
                        </form>
                    </Card>
                </div>
            </CenterLayout>
        );
    }
}

export default connect(selector)(ForgotPassword);
